import { DateTimeDetailValue } from "../../../../components/shared/details-cells/DateTimeDetailValue";
import DetailsCells from "../../../../components/shared/details-cells/DetailsCells";
import ACTION_LOGS_DATA_MODEL from "../../../../utils/constants/actionLogsDataModel";
import COMMON_LOGS_DATA_MODEL from "../../../../utils/constants/commonLogsDataModel";
import ActionLogFileList from "../../ActionLogFileList";
import ActionLogLinkDetailView from "../../ActionLogLinkDetailView";
import {
  ApproverUserName,
  CustomDetailsCellStyled,
  Flex,
  RunLogWrapper,
  SystemStatusCell,
  GxpReadyCell,
  ActionTypeCell,
  CreatedAtCell,
  CreatedTimeAtCell,
  GxpRelevantCell,
  ConfigurationBaselineCell
} from "../../common-for-log-sheet-and-run-logs/table-common-meta-info";
import { getDateTimeDisplay, formatUtcToLocal } from "../../../../utils/helpers/text";
import { DESCRIPTION_FIELD, APPROVE_ACTION_LOG_FIELD } from "../../../../utils/constants/descriptionField";
import { customItem } from "./customItem";

const actionTimeField = {
  label: ACTION_LOGS_DATA_MODEL.actionTime.value,
  component: ({ item }) => {
    if (item?.actionDateTime) {
      return <DateTimeDetailValue time={formatUtcToLocal(item.actionDateTime, { variant: 'time' })} skipTimeParse={true} />;
    }
    return <DateTimeDetailValue time={item?.actionTime} />;
  }
};

export const AttachmentDocs = {
  lookapVal: "attachments",
  field: ["attachments"],
  props: {
    style: { width: "50%" }
  },
  component: ({ item }) => <ActionLogFileList attachments={item.attachments} />
};

const externalDocs = {
  field: ["externalDocument"],
  lookapVal: "externalDocument",
  props: {
    style: { width: "50%" }
  },
  component: ({ item }) => {
    return <ActionLogLinkDetailView externalDocuments={item?.externalDocument} />;
  }
};

export const configurationDetailsField = customItem({
  dataModel: ACTION_LOGS_DATA_MODEL.configurationDetails,
  valueKey: "newValue",
  whiteSpace: true
});

export const LogSheetTableMeta = {
  expandable: true,
  ExpandedComponent: ({ item, infoMeta }) => (
    <Flex>
      <DetailsCells Wrapper={RunLogWrapper} item={item} infoMeta={infoMeta} CellWrapper={CustomDetailsCellStyled} />
    </Flex>
  ),
  //fields that are visible on clicking a chevron next to action log (expand view)
  expandedComponentProps: {
    infoMeta: {
      fields: [
        actionTimeField,
        {
          label: COMMON_LOGS_DATA_MODEL.createdAtTime.value,
          component: CreatedTimeAtCell
        },
        {
          label: COMMON_LOGS_DATA_MODEL.operatorUserName.value,
          field: ["operatorUserName"]
        },
        {
          label: ACTION_LOGS_DATA_MODEL.ecrNumber.value,
          field: ["ecrNumber"]
        },
        DESCRIPTION_FIELD,
        APPROVE_ACTION_LOG_FIELD,
        externalDocs,
        {
          label: "Equipment relevant attributes",
          lookapVal: "divider"
        },
        {
          label: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
          component: GxpRelevantCell
        },
        {
          label: ACTION_LOGS_DATA_MODEL.gxpReady.value,
          field: ["gxpReady"]
        },
        {
          label: ACTION_LOGS_DATA_MODEL.systemStatus.value,
          field: ["systemStatus"]
        },
        customItem({
          dataModel: ACTION_LOGS_DATA_MODEL.softwareVerison,
          valueKey: "newValue",
          whiteSpace: false
        }),
        customItem({
          dataModel: ACTION_LOGS_DATA_MODEL.configurationDetails,
          valueKey: "newValue",
          whiteSpace: true
        }),
        customItem({
          dataModel: ACTION_LOGS_DATA_MODEL.configurationBaseline,
          valueKey: "newValue",
          whiteSpace: true
        })
      ]
    }
  },
  // fields that are displayed in the Action Logs  main table (not centric view)
  fields: {
    detailExpander: {
      text: ""
    },
    actionDate: {
      sortable: true,
      text: ACTION_LOGS_DATA_MODEL.actionDate.value,
      component: ({ item }) => getDateTimeDisplay(item, 'actionDateTime', 'actionDate')
    },
    createdAt: {
      sortable: true,
      text: COMMON_LOGS_DATA_MODEL.createdAt.value,
      component: CreatedAtCell
    },
    equipmentModel: {
      text: COMMON_LOGS_DATA_MODEL.equipmentModel.value
    },
    serialNumber: {
      text: COMMON_LOGS_DATA_MODEL.serialNumber.value
    },
    equipmentId: {
      text: COMMON_LOGS_DATA_MODEL.equipmentId.value
    },
    equipmentNickName: {
      text: COMMON_LOGS_DATA_MODEL.equipmentNickName.value
    },
    action: {
      text: ACTION_LOGS_DATA_MODEL.actionType.value,
      component: ActionTypeCell
    },
    gxpRelevant: {
      text: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
      component: GxpRelevantCell
    },
    gxpReady: {
      text: ACTION_LOGS_DATA_MODEL.gxpReady.value,
      component: GxpReadyCell
    },
    systemStatus: {
      text: ACTION_LOGS_DATA_MODEL.systemStatus.value,
      component: SystemStatusCell
    },
    ...ApproverUserName,
    ecrNumber: {
      text: ACTION_LOGS_DATA_MODEL.ecrNumber.value
    },
    operatorUserName: {
      text: COMMON_LOGS_DATA_MODEL.operatorUserName.value
    },
    configurationBaseline: {
      text: ACTION_LOGS_DATA_MODEL.configurationBaseline.value,
      component: ConfigurationBaselineCell
    },
    description: {
      text: COMMON_LOGS_DATA_MODEL.description.value
    },
    approveStatus: {
      text: ACTION_LOGS_DATA_MODEL.approveStatus.value
    },
    configurationDetails: {
      text: ACTION_LOGS_DATA_MODEL.configurationDetails.value
    },
    softwareVersion: {
      text: ACTION_LOGS_DATA_MODEL.softwareVerison.value
    }
  }
};

export const LogSheetTableEquipmentCentricMeta = {
  expandable: true,
  ExpandedComponent: ({ item, infoMeta }) => (
    <Flex>
      <DetailsCells Wrapper={RunLogWrapper} item={item} infoMeta={infoMeta} CellWrapper={CustomDetailsCellStyled} />
    </Flex>
  ),
  expandedComponentProps: {
    infoMeta: {
      // fields that are displayed in the Action Logs  centric view table (not main Logs table)

      fields: [
        actionTimeField,
        {
          label: COMMON_LOGS_DATA_MODEL.createdAtTime.value,
          component: CreatedTimeAtCell
        },
        {
          label: COMMON_LOGS_DATA_MODEL.operatorUserName.value,
          field: ["operatorUserName"]
        },
        {
          label: ACTION_LOGS_DATA_MODEL.ecrNumber.value,
          field: ["ecrNumber"]
        },
        DESCRIPTION_FIELD,
        APPROVE_ACTION_LOG_FIELD,
        externalDocs,
        {
          label: "Equipment relevant attributes",
          lookapVal: "divider"
        },
        {
          label: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
          component: GxpRelevantCell
        },
        {
          label: ACTION_LOGS_DATA_MODEL.gxpReady.value,
          field: ["gxpReady"]
        },
        {
          label: ACTION_LOGS_DATA_MODEL.systemStatus.value,
          field: ["systemStatus"]
        },
        customItem({
          dataModel: ACTION_LOGS_DATA_MODEL.softwareVerison,
          valueKey: "newValue",
          whiteSpace: false
        }),
        customItem({
          dataModel: ACTION_LOGS_DATA_MODEL.configurationDetails,
          valueKey: "newValue",
          whiteSpace: true
        }),
        customItem({
          dataModel: ACTION_LOGS_DATA_MODEL.configurationBaseline,
          valueKey: "newValue",
          whiteSpace: true
        })
      ]
    }
  },
  fields: {
    detailExpander: {
      text: ""
    },
    actionDate: {
      sortable: true,
      text: ACTION_LOGS_DATA_MODEL.actionDate.value,
      component: ({ item }) => getDateTimeDisplay(item, 'actionDateTime', 'actionDate')
    },
    createdAt: {
      sortable: true,
      text: COMMON_LOGS_DATA_MODEL.createdAt.value,
      component: CreatedAtCell
    },
    action: {
      text: ACTION_LOGS_DATA_MODEL.actionType.value,
      component: ActionTypeCell
    },
    gxpRelevant: {
      text: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
      component: GxpRelevantCell
    },
    gxpReady: {
      text: ACTION_LOGS_DATA_MODEL.gxpReady.value,
      component: GxpReadyCell
    },
    systemStatus: {
      text: ACTION_LOGS_DATA_MODEL.systemStatus.value,
      component: SystemStatusCell
    },
    configurationBaseline: {
      text: ACTION_LOGS_DATA_MODEL.configurationBaseline.value,
      component: ConfigurationBaselineCell
    },
    ...ApproverUserName,
    ecrNumber: {
      text: ACTION_LOGS_DATA_MODEL.ecrNumber.value
    },
    operatorUserName: {
      text: COMMON_LOGS_DATA_MODEL.operatorUserName.value
    },
    description: {
      text: COMMON_LOGS_DATA_MODEL.description.value
    },
    configurationDetails: {
      text: ACTION_LOGS_DATA_MODEL.configurationDetails.value
    },
    softwareVersion: {
      text: ACTION_LOGS_DATA_MODEL.softwareVerison.value
    }
  }
};

export default LogSheetTableMeta;
